module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAQCAYAAAAI0W+oAAAAAXNSR0IArs4c6QAAAUhJREFUOE+9068vRXEYx/H33QRB0Nxgo9EIwt0ogmETGJF+i6HZMGyMoKFpisBomMKm2gTBRhD9AYIg+H7sc/w4u/f8uLbzlHO2c87z+j4/TomColSQQ16oGTgE+oAqcJn1oHkgIafAiJO/A+NZsaxQC3AODAAC7oGK76eBk7TKskBtIekF0OvEquLmV3UfwDywn4SlQR1GuoE3YMyIckbzmjKwDGzWw5IgIddAZxj8q5G7WKImYNeLoUdrwHotrB7U5UqEvACjwGNCa7ZCWxf9fANYib9bC+oxUjYy6GvavFddkd7bAxYAze8r4lC/EW3ZMzCUEYnyLQGqSHEMzHiB/kDDYbPOPOQHI5pN3pgDdgKo+WlbJ4RFFbUDT0ZuPRNtWaMxCRwZUxtnI6gVuHKbvsttVPF36tBBOPy2/rG0/+if1s/nhUGffLw7EfJTxI8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/drop-up.png
// module id = 8Yd/
// module chunks = 1